import { useNavigate } from "react-router-dom";
import "../styles/MessageModal.css";

export default function MessageModal({
  header,
  message,
  url = "/fourh",
  buttonText = "Agree",
  onConfirm,
}) {
  const navigate = useNavigate();

  const handleConfirm = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
    }

    if (/^https?:\/\//i.test(url)) {
      window.location.assign(url);
      return;
    }

    navigate(url);
  };

  return (
    <section
      className="messageModalDiv"
      role="dialog"
      aria-modal="true"
      aria-labelledby="message-modal-title"
    >
      <h1
        id="message-modal-title"
        className="messageModalHeader"
      >
        {header}
      </h1>

      <p className="messageModalP">
        {message}
      </p>

      <button
        className="messageModalBtn"
        type="button"
        onClick={handleConfirm}
      >
        {buttonText}
      </button>
    </section>
  );
}